// extracted by css-extract-rspack-plugin
export default {"link":"_9b8c8678"};